import React from 'react';
import LogoImage from '../../../assets/images/logo.svg';

const Decoration = ({ className = '', showLogo = false } = {}) => {
  return (
    <div data-test="decoration" className={`decoration ${className}`}>
      <div className="decoration__content-wrapper">
        <div className="decoration__content-wrapper__first_stripe"></div>
        <div className="decoration__content-wrapper__second_stripe"></div>
        <div className="decoration__content-wrapper__third_stripe"></div>
      </div>
      {showLogo && <LogoImage data-test="logo" className="w-40 h-auto " />}
    </div>
  );
};

export { Decoration };
